export const getToday = () => new Date().toISOString().split("T")[0];

// Coerce any value (null/undefined/strings from DDB, NaN from bad math) to a
// finite number. Returns 0 for anything that isn't finite so downstream
// formatters never produce "NaN" or "undefined" in the UI.
const toFiniteSeconds = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const formatTime = (totalSeconds) => {
  const n = toFiniteSeconds(totalSeconds);
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  const hours = Math.floor(abs / 3600);
  const minutes = Math.floor((abs % 3600) / 60);
  const seconds = Math.floor(abs % 60);
  return `${sign}${hours > 0 ? hours + "h " : ""}${minutes > 0 ? minutes + "m " : ""}${seconds}s`;
};

// Like formatTime but minute resolution ("68h 21m", "45m"), rounded to the
// nearest minute. Used where seconds are noise (e.g. the Hours Left card).
export const formatTimeMinutes = (totalSeconds) => {
  const n = toFiniteSeconds(totalSeconds);
  const sign = n < 0 ? "-" : "";
  const totalMinutes = Math.round(Math.abs(n) / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${sign}${hours > 0 ? hours + "h " : ""}${minutes}m`;
};

// Compact playback display: HH:MM:SS (when >= 1h) or MM:SS otherwise.
// Also used by the upload form to render a video's runtime.
export const formatPlaybackTime = (seconds) => {
  const n = toFiniteSeconds(seconds);
  const abs = Math.abs(n);
  const hrs = Math.floor(abs / 3600);
  const mins = Math.floor((abs % 3600) / 60);
  const secs = Math.floor(abs % 60);
  const sign = n < 0 ? "-" : "";
  if (hrs > 0)
    return `${sign}${hrs}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  return `${sign}${mins}:${secs.toString().padStart(2, "0")}`;
};
